import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex row align-items-center text-secondary col-12" }
const _hoisted_2 = {
  selected: "",
  value: "",
  class: "text-secondary"
}
const _hoisted_3 = ["value"]

import { segmentationObject } from "@/interfaces";
import BaseSelect from "@/components/base-components/BaseSelect.vue";
import { ref, PropType, onBeforeMount } from "vue";


const __default__ = {
  name: "ProjectFilters",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  segmentations: {
    type: Array as PropType<Array<segmentationObject>>,
  },
},
  emits: ["filter"],
  setup(__props, { emit }) {

const props = __props;

const form = ref({});




onBeforeMount(() => {
  if (props.segmentations) {
    props.segmentations.forEach((segmentation) => {
      form.value[segmentation.id] = "";
    });
  }
});

const filterClicked = () => {
  emit("filter", form.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.segmentations, (segmentation, i) => {
        return (_openBlock(), _createBlock(BaseSelect, {
          value: form.value[segmentation.id],
          "onUpdate:value": ($event: any) => ((form.value[segmentation.id]) = $event),
          name: "filter-gender",
          class: "col-md-4 my-2",
          key: i
        }, {
          default: _withCtx(() => [
            _createElementVNode("option", _hoisted_2, _toDisplayString(segmentation.label), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentation.options, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option,
                class: "text-secondary"
              }, _toDisplayString(option), 9, _hoisted_3))
            }), 128))
          ]),
          _: 2
        }, 1032, ["value", "onUpdate:value"]))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "col-4 col-sm-2 ms-auto mt-3 btn btn-primary text-light rounded-pill me-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (filterClicked()))
    }, " Filter ")
  ], 64))
}
}

})